var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BookingRequests',{attrs:{"booking-requests":_vm.bookingRequests,"adventure-types":_vm.adventureTypes,"hunt-types":_vm.huntTypes,"hunt-species-list":_vm.huntSpeciesList},on:{"updateBooking":_vm.updateBookingRequest}})}
var staticRenderFns = []

export { render, staticRenderFns }